import { SGK_GROUPS, groupTotal, pctStr } from "./sgkConst";
import SgkRateRow from "./SgkRateRow";
import SgkDiscountRows from "./SgkDiscountRows";

const TH = ({ children, className = "" }) => <th className={`px-3 py-1.5 text-[11px] uppercase tracking-wide text-slate-700 font-semibold bg-slate-200 ${className}`}>{children}</th>;

// Görseldeki SGK prim tablosu: 3 blok (4/1-a sigorta kolları + otomatik Toplam satırı, MYÖ fiili hizmet, SGDP); editable=true ise hücreler input
export default function SgkRateTable({ rates, editable = false, onChange, prefix = "sgk" }) {
  return (
    <div className="overflow-x-auto rounded-md border border-slate-300" data-testid={`${prefix}-table`}>
      <table className="w-full min-w-[640px]">
        <thead>
          <tr><TH className="text-left w-[40%]">Sigorta Kolu</TH><TH>İşveren Payı (%)</TH><TH>Çalışan Payı (%)</TH><TH>Toplam (%)</TH></tr>
        </thead>
        <tbody>
          {SGK_GROUPS.map((g) => {
            const t = g.withTotal ? groupTotal(rates, g.rows.map((r) => r[0])) : null;
            return [
              <tr key={`${g.key}-title`} className="border-t border-slate-300 bg-white"><td colSpan={4} className="px-3 pt-3 pb-1 text-sm font-bold text-sky-700" data-testid={`${prefix}-group-${g.key}`}>{g.title}</td></tr>,
              ...g.rows.map(([k, label]) => <SgkRateRow key={k} rowKey={k} label={label} values={rates[k]} editable={editable} extraLabel={g.extraLabel} onChange={onChange} prefix={prefix} />),
              t && (
                <tr key={`${g.key}-total`} className="border-t border-slate-300 bg-slate-200 font-bold" data-testid={`${prefix}-total-${g.key}`}>
                  <td className="px-3 py-1.5 text-sm">Toplam</td>
                  <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-${g.key}-employer`}>{pctStr(t.employer)}</td>
                  <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-${g.key}-employee`}>{pctStr(t.employee)}</td>
                  <td className="px-3 py-1.5 text-sm text-center" data-testid={`${prefix}-total-${g.key}-total`}>{pctStr(t.total)}</td>
                </tr>
              ),
              t && g.discountKey && <SgkDiscountRows key={`${g.key}-disc`} value={rates[g.discountKey]?.employer} total={t} editable={editable} onChange={onChange} prefix={prefix} />,
            ];
          })}
        </tbody>
      </table>
    </div>
  );
}
